import { uniqBy } from "lodash-es"

function unique<T>(array: T[]) {
  return uniqBy(array, "id")
}

export default unique
